import React from 'react';
import { DEFAULT_FONT_FAMILY } from '../../rich_text_editor/tiptap_editor';

type PreviewBodyProps = {
  body: string;
};

export default function PreviewBody({ body }: PreviewBodyProps) {
  return (
    <div className="pt-6">
      <div
        dangerouslySetInnerHTML={{ __html: body }}
        style={{ fontFamily: DEFAULT_FONT_FAMILY }}
      />
    </div>
  );
}
